webpackJsonp([44002203199707],{

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    flex-direction: row;\n  '], ['\n    flex-direction: row;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    margin-right: 1em;\n  '], ['\n    margin-right: 1em;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    min-width: 33.33%;\n'], ['\n    min-width: 33.33%;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(4);
	
	var _gatsbyImage = __webpack_require__(21);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(39);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Layout = __webpack_require__(12);
	
	var _colors = __webpack_require__(10);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _media = __webpack_require__(16);
	
	var _media2 = _interopRequireDefault(_media);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } /* eslint-disable no-undef, react/prop-types */
	
	
	var style = /*#__PURE__*/(0, _reactEmotion.css)('text-align:center;padding-bottom:10%;margin-top:3.5rem;p{margin-bottom:1em;}& ul{list-style-type:none;color:', _colors2.default.primary, ';}a{color:', _colors2.default.primary, ';text-decoration:underline;&:hover{text-decoration:none;}}h1,h2{margin-top:0;padding-bottom:0.5em;}min-width:33.33%;');
	
	var flexStyle = /*#__PURE__*/(0, _reactEmotion.css)('margin-top:3.5rem;flex-wrap:nowrap;flex-direction:column;justify-content:space-around;', _media2.default.mid(_templateObject), ';');
	
	var emptyColStyle = /*#__PURE__*/(0, _reactEmotion.css)('min-width:33.33%;');
	
	var imgStyle = /*#__PURE__*/(0, _reactEmotion.css)('margin-top:2rem;margin-bottom:1em;margin-right:auto;margin-left:auto;box-sizing:content-box;', _media2.default.mid(_templateObject2), ';');
	
	var outerImgWrapper = /*#__PURE__*/(0, _reactEmotion.css)('width:8em;min-width:60%;align-self:center;', _media2.default.mid(_templateObject3), ';');
	
	var Naytokset = function Naytokset(_ref) {
	  var data = _ref.data;
	  var hygieia = data.hygieia;
	
	  return _react2.default.createElement(
	    _Layout.Box,
	    null,
	    _react2.default.createElement(
	      _Layout.Flex,
	      { className: flexStyle },
	      _react2.default.createElement('div', { className: emptyColStyle }),
	      _react2.default.createElement(
	        'div',
	        { className: style, color: _colors2.default.secondary },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Ensi-ilta'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Keskiviikkona 6. kes\xE4kuuta 2018 kello 19'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Muut esitykset'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Torstaina 7.6.2018 kello 18'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Perjantaina 8.6.2018 kello 18'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Lauantaina 9.6.2018 kello 14'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Lauantaina 9.6.2018 kello 18'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Sunnuntaina 10.6.2018 kello 13'
	          )
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Esityspaikka'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Valvesali, Kulttuuritalo Valve',
	          _react2.default.createElement('br', null),
	          'Hallituskatu 7, 90100 Oulu',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(
	              'small',
	              null,
	              'Esityksen kesto noin 1h 50 min sis\xE4lt\xE4en v\xE4liajan'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            href: 'https://www.ticketmaster.fi/search/?keyword=owla+ja+kadonnut+walkia',
	            target: '_blank',
	            rel: 'noopener'
	          },
	          'T\xE4st\xE4 lippukauppaan'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Kiertue'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Pispalan Sottiisi'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Tullikamarin Pakkahuone, Tampere',
	          _react2.default.createElement('br', null),
	          'Perjantaina 15. kes\xE4kuuta 2018 kello 19'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Kaustinen Folk Music Festival'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Areena, Kaustinen',
	          _react2.default.createElement('br', null),
	          'Lauantaina 14. hein\xE4kuuta 2018'
	        )
	      ),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        className: imgStyle,
	        outerWrapperClassName: outerImgWrapper,
	        alt: 'Hygieia tanssii, Kuvaaja: Inkeri J\xE4ntti',
	        sizes: hygieia.childImageSharp.sizes,
	        imgStyle: {
	          objectFit: 'contain',
	          width: '100%',
	          height: '50vh',
	          boxSizing: 'content-box'
	        }
	      })
	    )
	  );
	};
	var query = exports.query = '** extracted graphql fragment **';
	exports.default = Naytokset;

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactEmotion = __webpack_require__(4);
	
	var sizes = {
	  large: 1024,
	  mid: 832,
	  small: 640
	};
	
	// Iterate through the sizes and create a media template
	var media = Object.keys(sizes).reduce(function (acc, label) {
	  acc[label] = function () {
	    return (/*#__PURE__*/(0, _reactEmotion.css)('@media (min-width:', sizes[label] / 16, 'em){', /*#__PURE__*/_reactEmotion.css.apply(undefined, arguments), ';}')
	    );
	  };
	
	  return acc;
	}, {});
	
	exports.default = media;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-naytokset-js-1eb920ad444f4bf5af5e.js